import { useSpaceStore } from "../../stores";
import "./NavBar.css";

export function NavBar() {
	const viewMode = useSpaceStore((s) => s.viewMode);
	const focusedSystem = useSpaceStore((s) => s.focusedSystem);
	const exitSystemView = useSpaceStore((s) => s.exitSystemView);
	const view = useSpaceStore((s) => (s.viewMode === "galaxy" ? s.galaxyView : s.systemView));
	const resetView = useSpaceStore((s) => s.resetView);
	const zoom = useSpaceStore((s) => s.zoom);

	const isSystemView = viewMode === "system";
	const maxZoom = isSystemView ? 50 : 5;
	const minZoom = isSystemView ? 0.5 : 0.3;

	return (
		<nav className="navbar">
			{isSystemView && (
				<button
					type="button"
					className="nav-btn nav-btn-back"
					onClick={exitSystemView}
					title="Back to Galaxy"
				>
					<svg
						width="18"
						height="18"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
					>
						<title>Back</title>
						<path d="M19 12H5M12 19l-7-7 7-7" />
					</svg>
				</button>
			)}

			<div className="navbar-brand">
				<svg className="navbar-logo" width="28" height="28" viewBox="0 0 64 64" fill="none">
					<title>Voidex</title>
					<defs>
						<linearGradient id="navGrad" x1="0%" y1="0%" x2="100%" y2="100%">
							<stop offset="0%" style={{ stopColor: "#2DD4A8" }} />
							<stop offset="100%" style={{ stopColor: "#A87C4F" }} />
						</linearGradient>
					</defs>
					<circle
						cx="32"
						cy="32"
						r="28"
						stroke="url(#navGrad)"
						strokeWidth="3"
						fill="transparent"
					/>
					<circle cx="32" cy="24" r="5" fill="url(#navGrad)" />
					<circle cx="20" cy="38" r="3" fill="#E5A040" />
					<circle cx="44" cy="36" r="4" fill="#A87C4F" />
				</svg>
				<span className="navbar-title">
					{isSystemView && focusedSystem ? focusedSystem.star.name : "Voidex"}
				</span>
			</div>

			<div className="navbar-controls">
				<button
					type="button"
					className="nav-btn"
					onClick={() => zoom(1.5)}
					title="Zoom in"
					disabled={view.scale >= maxZoom}
				>
					<svg
						width="18"
						height="18"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
					>
						<title>Zoom in</title>
						<circle cx="11" cy="11" r="8" />
						<path d="M21 21l-4.35-4.35M11 8v6M8 11h6" />
					</svg>
				</button>
				<button
					type="button"
					className="nav-btn"
					onClick={() => zoom(0.667)}
					title="Zoom out"
					disabled={view.scale <= minZoom}
				>
					<svg
						width="18"
						height="18"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
					>
						<title>Zoom out</title>
						<circle cx="11" cy="11" r="8" />
						<path d="M21 21l-4.35-4.35M8 11h6" />
					</svg>
				</button>
				<button type="button" className="nav-btn" onClick={resetView} title="Reset view">
					<svg
						width="18"
						height="18"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
					>
						<title>Reset view</title>
						<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
						<path d="M3 3v5h5" />
					</svg>
				</button>
			</div>

			<div className="navbar-info">
				<span className="navbar-hint">
					{isSystemView
						? "ESC to return · Drag to pan"
						: "Drag to pan · Scroll to zoom · Click star to enter"}
				</span>
			</div>
		</nav>
	);
}
